import { memo, useRef, useState, useCallback } from 'react'

import ActionButton from '../ActionButton'
import VolumeIcon from 'assets/svgr-icons/Volume.svg'
import VolumeMuteIcon from 'assets/svgr-icons/VolumeMute.svg'

import * as Styled from './styled'
import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'
import { FadeSlider } from 'containers/SubSidebar/AudioContent/components/fade-slider'
import VolumeSlider from 'containers/SubSidebar/AudioContent/components/volume-slider'
import { useSelectedAudioVolumeUpdatesHandler } from 'containers/SubSidebar/AudioContent/hooks'

const VolumeControlButton = () => {
  // Same source of truth as the in-flyout slider, so the icon and the panel
  // never disagree (e.g. a fresh clip with no volume set reads as full, not muted).
  const { volume } = useSelectedAudioVolumeUpdatesHandler()
  const isMuted = volume === 0

  const [isOpen, setIsOpen] = useState(false)
  const buttonRef = useRef<HTMLButtonElement>(null)

  const onClose = useCallback(() => {
    setIsOpen(false)
  }, [])

  const toggleFlyout = useCallback(() => {
    setIsOpen(prev => !prev)
  }, [])

  return (
    <>
      <ActionButton
        ref={buttonRef}
        icon={isMuted ? <VolumeMuteIcon /> : <VolumeIcon />}
        tooltipText={!isOpen ? translate(T.VOLUME) : ''}
        onClick={toggleFlyout}
      />
      <Styled.Flyout
        isOpen={isOpen}
        onClose={onClose}
        anchorEl={buttonRef.current}
        options={{
          position: 'top',
          extraOffset: 10
        }}
      >
        <Styled.FlyoutContent>
          <VolumeSlider />
          <FadeSlider label={T.FADE_IN_LABEL} type="fade-in" />
          <FadeSlider label={T.FADE_OUT_LABEL} type="fade-out" />
        </Styled.FlyoutContent>
      </Styled.Flyout>
    </>
  )
}

export default memo(VolumeControlButton)
